import { useFlowConfigStore } from '@/store/flow-config.store'
import { useFlowStore } from '@/store/flow.store.ts'
import { DEVICE_ID, USER_ID } from '@/utils/constants'
import type { Nullish } from '@logistiek-zonder-papier/lzp-library'
import { evaluate } from '@marcbachmann/cel-js'
import { format, parse } from 'date-fns'
import i18next from 'i18next'
import { v4 } from 'uuid'

export function createLibraryContext() {
  return {
    deviceId: () => localStorage.getItem(DEVICE_ID) ?? v4(),
    flowData: () => useFlowStore().flowData,
    globalData: () => useFlowStore().globalData,
    subAppId: () => useFlowConfigStore().config?.subAppId,
    userId: () => localStorage.getItem(USER_ID) ?? 'user-id',
    dateTimeLocal: () => new Date().toLocaleString('sv-SE'),
    dateTimeIso: () => new Date().toISOString(),
    genUuid: () => v4(),
    licensePlate: () => 'licensePlate',
    licensePlateBgb: () => 'licensePlate',
    i18n: (translationKey: string) => i18next.t(translationKey),
    geoLocation: () => ({ latitude: 0.0, longitude: 0.0 }),
    bgbBaseUrl: () => import.meta.env['VITE_BGB_BASE_URL'],
    null: () => null,
    undefined: () => undefined,
    formatDate: (input: string, formatStr: string, inputFormatStr?: string | Nullish) => {
      try {
        let date = new Date(input)

        if (isNaN(date.getMilliseconds()) && inputFormatStr != null) {
          date = parse(input, inputFormatStr, new Date())
        }

        return format(date, formatStr)
      } catch {
        return 'Invalid Date'
      }
    },
    expr: (expression: string, context?: Record<string, unknown> | Nullish) => {
      try {
        if (typeof expression !== 'string') return null

        const evaluatedContext = context ?? useFlowStore().flowData

        const result = evaluate(expression, evaluatedContext)
        if (typeof result === 'bigint') {
          return Number(result)
        }
        return result
      } catch {
        return
      }
    },
  }
}
